import React from 'react'
import classNames from 'classnames'
import { useNavigate } from 'react-router-dom'

import Image from '../ui/Image/Image'

import styles from './Breadcrumbs.module.scss'
import Home from '../../assets/images/home.svg'
import Separator from '../../assets/images/right-angular-arrow.svg'
import { useLanguage } from '../../context/LangaugeContextProvider/LangaugeContextProvider'
import { isArabic } from '../../utils'

const Breadcrumbs = ({ breadcrumbs, className }) => {
  const navigate = useNavigate()
  const handleNavigation = (breadcrumb) => {
    navigate(breadcrumb?.link?.path)
  }
  const { language } = useLanguage()

  return (
    <div className={classNames(styles['outer-container'], className)}>
      <div
        className={classNames(
          styles['inner-container'],
          'h-100 flex flex-wrap items-center'
        )}
      >
        {breadcrumbs?.map((breadcrumb, index) => {
          return (
            <React.Fragment key={'breadcrumbs' + breadcrumb.id}>
              {index === 0 && (
                <button
                  aria-label={'Go To Home'}
                  onClick={() => handleNavigation(breadcrumb)}
                >
                  <Image src={Home} alt="Home" />
                </button>
              )}
              {index !== breadcrumbs.length && index !== 0 && (
                <Image
                  src={Separator}
                  alt="Separator"
                  className={classNames(styles.separator, {
                    [styles.arabic_separator]: isArabic(language?.code),
                  })}
                />
              )}
              {index !== 0 && (
                <button
                  aria-label={breadcrumb?.link?.label}
                  className={classNames(
                    index === breadcrumbs.length - 1
                      ? 'font-semibold'
                      : 'font-normal cursor-pointer',
                    styles.item
                  )}
                  onClick={() => handleNavigation(breadcrumb)}
                >
                  {breadcrumb?.link?.label}
                </button>
              )}
            </React.Fragment>
          )
        })}
      </div>
    </div>
  )
}

export default Breadcrumbs
